import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetInitialLiveCall} from "../../apis/user";
import {LIVE_INITIALIZE_ERROR, LIVE_INITIALIZE_SUCCESS} from "../../constants/LiveConstants";

function* tryFunction() {
    const response: Record<string, string> = yield call(GetInitialLiveCall);
    yield put({
        type: LIVE_INITIALIZE_SUCCESS,
        payload: response
    });
}

export function* initializeLiveSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: LIVE_INITIALIZE_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}